import { courseLearningData } from "./mocks/courseLearning"

/**
 * Utility class for course learning
 */
export class CourseLearningUtils {
  private constructor() {}

  /**
   * Get course learning details by course type slug
   * @param courseTypeSlug course type slug
   * @returns course learning details
   */
  public static getCourseLearningDetailsByCourseTypeSlug(courseTypeSlug: string, lessionsMode: string, certificateReleaseEntity: string[] = []) {
    // Get course learning details by course type slug and lessions mode, if certificateReleaseEntity is provided select the course learning details by certificateReleaseEntity
    let result = courseLearningData[courseTypeSlug] || null;
    if (!result) return null;
    if (certificateReleaseEntity.length > 0) {
      result = result.filter((item) => item.certificateReleaseEntity.some((entity) => certificateReleaseEntity.includes(entity)));
    }
    if (!result) return null;
    result = result.find((item) => item.lessionsMode[lessionsMode]);
    if (!result) return null;
    return result.lessionsMode[lessionsMode];
  }
}
